<template>
  <div
    class="offcanvas offcanvas-end"
    tabindex="-1"
    id="sidebar"
    aria-labelledby="offcanvasExampleLabel"
  >
    <div class="pe-2 ps-4 pb-3 pt-2">
      <div class="close-button text-end pt-2 pe-2">
        <button
          type="button"
          class="btn-close btn-sm"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div class="sidebar-header">
        <h6 class="mb-2">Logged in as</h6>
        <span class="identity-text mt-3" style="font-size: 16px">
          {{ userData.firstName }}, {{ userData.lastName }}
        </span>
        <br />
        <span class="identity-text"> {{ userData.role }} </span> <br />
        <a
          class="anchor-link me-2"
          style="font-size: 12px"
          href="javascript:void(0)"
          data-bs-dismiss="offcanvas"
          data-bs-target="#sidebar"
          @click="goToProfile"
        >
          View Profile
          <font-awesome-icon icon="fa-arrow-right fa-solid" class="fa-sm" />
        </a>
      </div>
    </div>

    <div class="sidebar-menu">
      <ul class="nav nav-pills flex-column mb-auto">
        <li v-for="(item, index) in getMenu" :key="index">
          <div
            style="display: flex; margin-top: 0.5em"
            class="sidebar-link-container pl-2 pt-1 pb-1"
          >
            <font-awesome-icon
              :icon="item.icon"
              class="text-dark me-2 mt-1 fa-sm"
            />
            <a
              :href="item.href"
              class="link-dark font-weight-light sidebar-link"
              style="width: 100%"
            >
              {{ item.text }}
            </a>
          </div>
        </li>
        <li>
          <div
            style="display: flex; margin: 0.5em 0"
            class="sidebar-link-container pl-2 pt-1 pb-1"
          >
            <font-awesome-icon
              icon="fa-power-off fa-solid"
              class="text-dark me-2 mt-1 fa-sm"
            />
            <a
              href="javascript:void(0)"
              class="sidebar-link link-dark font-weight-light"
              style="width: 100%"
              data-bs-dismiss="offcanvas"
              data-bs-target="#sidebar"
              @click="$emit('action:logout')"
            >
              Logout
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  props: {
    userData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    getMenu() {
      const { menus } = this.$store._state.data.sidebar;
      return menus;
    },
  },
  methods: {
    goToProfile() {
      this.$router.push({
        name: "profilePage",
        params: {
          id: localStorage.getItem("businessKey"),
        },
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/style/color.scss";

.sidebar-link {
  text-align: left;
  font-size: 13px;
  color: $primary-ui !important;
  text-decoration: none;

  &:hover {
    color: $button-background !important;
  }
}
</style>
